var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeatSpeakers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-speakers",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa8600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff220c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72153",
    "data-name": "Group 72153",
    transform: "translate(-753 -14207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "all-light",
    d: "M8,0h4a8,8,0,0,1,8,8V20a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V8A8,8,0,0,1,8,0Z",
    transform: "translate(753 14207)",
    fill: "url(#linear-gradient-speakers)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bottom-dark",
    width: 20,
    height: 5,
    transform: "translate(753 14222)",
    fill: "#795021"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatSpeakers);
export default __webpack_public_path__ + "static/media/seat_speakers.46460d36a52c9ca70817a9f4f44a3322.svg";
export { ForwardRef as ReactComponent };